<div class="aqa-head">
  <div>
    <h3>Your next best actions</h3>
    <p>Fast ways into the experiences that matter to you.</p>
  </div>
  <button type="button" class="aqa-link" (click)="browseEvents.emit()">Browse all events →</button>
</div>
<div class="aqa-grid">
  <button type="button" *ngFor="let action of actions" class="aqa-item" (click)="actionSelected.emit(action.message)">
    <span class="aqa-icon"><span class="material-icons">{{ action.icon }}</span></span>
    <span class="aqa-text">
      <strong>{{ action.label }}</strong>
      <small>{{ action.sublabel }}</small>
    </span>
  </button>
</div>
